const parseVersion = (version) => {
    if (!version) return [0, 0, 0];

    const parts = version.split(".");
    return [
        parseInt(parts[0] || 0, 10),
        parseInt(parts[1] || 0, 10),
        parseInt(parts[2] || 0, 10),
    ];
};

export const sortReleases = (a, b) => {
    if (a === undefined) return -1;
    if (b === undefined) return 1;

    const versionA = parseVersion(a.version);
    const versionB = parseVersion(b.version);

    for (let i = 0; i < 3; i++) {
        if (versionA[i] !== versionB[i]) {
            return versionB[i] - versionA[i];
        }
    }

    return 0;
};
